// extracted by mini-css-extract-plugin
export default {"navigation__list":"navigation_navigation__list__40GaA","navigation__item":"navigation_navigation__item__wvEV3"};